<div #mapViewNode></div>
